import React, { useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import useCharts, { ChartData } from '../../Hooks/useChart';
import { Chart } from '../../Enums/Chart.enum';
import LineChart from '../../../../Components/Chart/LineChart';
import { useEffectAsync } from '../../../../helpers';
import { useAppContext } from '../../../../Services/AppContext';
// @ts-ignore
import styles from './HealthDataChart.module.scss';

interface HealthDataBaseChartProps {
	patientId: string;
	view: string;
	source: string[];
	keys: string[];
	from: string | any;
	to: string | any;
	chartType: Chart;
	chartTitle: string;
	type?: string;
	healthData?: any;
	isLoading?: boolean;
}

const HealthDataBaseChart: React.FC<HealthDataBaseChartProps> = props => {
	const { view, chartType, chartTitle, healthData } = props;
	const { getChartsData } = useCharts();
	const { language } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);
	const [chartOptions, setChartOptions] = useState<any>();
	const [chartData, setChartData] = useState<ChartData>({
		labels: [],
		datasets: [],
	});

	useEffectAsync(async () => {
		setIsLoading(true);
		const { chartData, chartOptions } = getChartsData(
			healthData,
			chartType,
			view,
			language,
			chartType === Chart.ESAS,
		);
		setChartData(chartData);
		setChartOptions(chartOptions);
		setIsLoading(false);
	}, [healthData]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<Text className={styles.title} tx={chartTitle} firstUpper />
			</div>
			<LineChart
				data={chartData}
				isLoading={isLoading || props.isLoading}
				options={chartOptions}
			/>
		</div>
	);
};

export default HealthDataBaseChart;
